import React, { memo } from "react";
import { Button, Stack } from "@mui/material";
import MergeIcon from "@mui/icons-material/Merge";
import BlockIcon from "@mui/icons-material/Block";
import RefreshIcon from "@mui/icons-material/Refresh";
import DescriptionIcon from "@mui/icons-material/Description";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import UploadIcon from "@mui/icons-material/Upload";
import { toast } from "react-toastify";

function ActionsBar({ uhid, onConsent, onSmartCard }) {
  const disabled = !uhid;
  const act = (label) => toast.success(`${label} (mock)`);

  return (
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {/* <Button size="small" variant="outlined" disabled={disabled} startIcon={<MergeIcon />} onClick={() => act("Merge UHID")}>Merge UHID</Button> */}
      {/* <Button size="small" variant="outlined" disabled={disabled} startIcon={<BlockIcon />} onClick={() => act("Deactivated")}>Deactivate</Button> */}
      {/* <Button size="small" variant="outlined" disabled={disabled} startIcon={<RefreshIcon />} onClick={() => act("Registration renewed")}>Renew</Button> */}
      <Button size="small" variant="outlined" startIcon={<DescriptionIcon />} onClick={onConsent}>Consent Form</Button>
      <Button size="small" variant="outlined" disabled={disabled} startIcon={<CreditCardIcon />} onClick={onSmartCard}>Smart Card</Button>
      {/* <Button size="small" variant="outlined" startIcon={<UploadIcon />} onClick={() => act("Bulk camp upload")}>Bulk Upload</Button> */}
    </Stack>
  );
}

export default memo(ActionsBar);
